<template>
  <div class="w-full max-w-5xl mx-auto mt-24">
    <h1 class="text-white text-xl font-semibold mb-3">{{ t.pageTitle }}</h1>

    <section class="w-full rounded-xl border border-[#343743] bg-[#17191f]/95 p-4 shadow-2xl sm:p-6 md:p-8">
      <div class="flex flex-col items-center text-center">
        <div class="flex h-14 w-14 items-center justify-center rounded-full border border-[#63E6BE] bg-[#63E6BE]/10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            class="h-6 w-6 text-[#63E6BE]"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="m5 13 4 4L19 7" />
          </svg>
        </div>

        <h2 class="mt-4 text-4xl text-white md:text-5xl font-bold">{{ t.title }}</h2>
        <p class="mt-3 max-w-3xl text-xl text-gray-400">{{ t.subtitle }}</p>
      </div>

      <div class="mt-6 rounded-xl bg-[#22242d] p-4 md:p-5 text-sm">
        <div class="space-y-4">
          <div class="flex items-center justify-between gap-3" dir="ltr">
            <span class="text-gray-400">{{ t.numberLabel }}</span>
            <span class="font-semibold text-white">{{ maskedPhone }}</span>
          </div>

          <div class="flex items-center justify-between gap-3" dir="ltr">
            <span class="text-gray-400">{{ t.cifLabel }}</span>
            <span class="font-semibold text-white">{{ cif }}</span>
          </div>

          <div class="flex items-center justify-between gap-3" dir="ltr">
            <span class="text-gray-400">{{ t.renewalLabel }}</span>
            <span class="font-semibold text-white">{{ t.nextMonth }} — {{ renewalAmount }} {{ t.currencySuffix }}</span>
          </div>
        </div>
      </div>

      <footer class="flex justify-between border-t border-white/10 py-3 mt-6">
        <img src="@/assets/nasna-logo-bok.svg" alt="nasna-logo" class="h-8 w-auto object-cover" />
        <img src="@/assets/bok.png" alt="bok-logo" class="h-8 object-cover" />
      </footer>
    </section>
  </div>
</template>

<script>
import { bokSuccessTrs } from "@/bok.trs";

export default {
  props: {
    currentLanguage: {
      type: String,
      required: true,
    },
    details: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    t() {
      return bokSuccessTrs[this.currentLanguage] || bokSuccessTrs.en;
    },
    maskedPhone() {
      const phone = String(this.details.phone || "249******999").replace(/\D/g, "");
      if (phone.length < 6) {
        return this.details.phone || "+249 ****** 999";
      }

      const lastThree = phone.slice(-3);
      return `+249 ****** ${lastThree}`;
    },
    cif() {
      return this.details.cif || "-";
    },
    renewalAmount() {
      return this.details.price || "9,800.00";
    },
  },
};
</script>
